import { and, i18nScope, plugin, role } from '../condition.js';
import type { ProductMenuDef } from '../type.js';

/**
 * VoC の L2 メニュー定義。
 * 出典: navigation-v5/src/constants/level2/voc.ts
 *
 * 出し分け条件は計画書 §7.1 (v5 parity 表) に準拠。
 * - L1 (VoC 自体): `hasRole('VOC','view')` + `i18n(scope=false)`
 *   (v5 にあった `!plugin:righttouch_qant_global_nav` 排他ゲートは v2 では
 *    `globalNaviV2Enabled` フラグが担うため省略。§7.4 注 参照)
 * - BASIC 各メニュー: `i18n(scope=false)`
 * - REVIEW_REPORT: `i18n(scope=false)` + `isEnabledVocReview()` (= plugin:voc_review)
 */
export const QANT_VOC_MENU = {
  product: {
    name: 'voc',
    icon: 'qantVoc',
    label: { ja: 'VoC', en: 'VoC' },
    description: { ja: 'VoC管理・分析', en: 'VoC Management & Analytics' },
  },
  condition: and(role('VOC', 'view'), i18nScope(false)),
  menuGroups: {
    BASIC: {
      name: 'basic',
      menus: {
        DASHBOARD: {
          name: 'dashboard',
          icon: 'vocDashboard',
          label: { ja: 'ダッシュボード', en: 'Dashboard' },
          path: { host: 'karte-io', path: '/voc/' },
          condition: i18nScope(false),
        },
        PAINS: {
          name: 'pains',
          icon: 'vocTopics',
          label: { ja: 'トピック', en: 'Topic' },
          path: { host: 'karte-io', path: '/voc/topics' },
          condition: i18nScope(false),
        },
        ISSUES: {
          name: 'issues',
          icon: 'vocIssues',
          label: { ja: 'チケット', en: 'Issue' },
          path: { host: 'karte-io', path: '/voc/issues' },
          condition: i18nScope(false),
        },
        SETTINGS: {
          name: 'settings',
          icon: 'setting',
          label: { ja: '設定', en: 'Settings' },
          path: { host: 'karte-io', path: '/voc/settings' },
          condition: i18nScope(false),
        },
      },
    },
    VOC_REVIEW: {
      name: 'vocReview',
      label: { ja: '応対品質評価', en: 'Response Quality Review' },
      menus: {
        REVIEW_REPORT: {
          name: 'reviewReport',
          icon: 'vocAnalytics',
          label: { ja: '総合評価', en: 'Overall Review' },
          path: { host: 'karte-io', path: '/voc/review/report' },
          condition: and(i18nScope(false), plugin('voc_review')),
        },
      },
    },
  },
} as const satisfies ProductMenuDef;
